import { render, staticRenderFns } from "./Patient-Tracking.vue?vue&type=template&id=0a505506&scoped=true"
import script from "./Patient-Tracking.vue?vue&type=script&lang=js"
export * from "./Patient-Tracking.vue?vue&type=script&lang=js"
import style0 from "./Patient-Tracking.vue?vue&type=style&index=0&id=0a505506&prod&lang=css"
import style1 from "./Patient-Tracking.vue?vue&type=style&index=1&id=0a505506&prod&lang=scss"
import style2 from "./Patient-Tracking.vue?vue&type=style&index=2&id=0a505506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a505506",
  null
  
)

export default component.exports